import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const C = { rose: '#e3425c', creamDark: '#ebebed', dark: '#1c1c1e', white: '#ffffff' };

export default function AcceptableUse() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--cream)' }}>
      <nav style={{ position: 'sticky', top: 0, zIndex: 100, background: 'rgba(255,255,255,0.97)', backdropFilter: 'blur(20px)', borderBottom: `1px solid ${C.creamDark}`, padding: '14px 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 28px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to='/' style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: C.dark, fontSize: '14px', fontWeight: 500 }}>
            <FiArrowLeft size={16} />
            <img src="/ggr-logo-deck.png" alt='GGR' style={{ height: '50px', width: 'auto' }} />
          </Link>
          <Link to='/register' style={{ padding: '10px 22px', borderRadius: '8px', background: C.rose, color: C.white, textDecoration: 'none', fontSize: '13px', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>
            Get Started
          </Link>
        </div>
      </nav>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        <div className="card" style={{ padding: '40px' }}>
          <h1 style={{ fontSize: '28px', marginBottom: '8px' }}>Acceptable Use Policy</h1>
          <p style={{ color: 'var(--gray)', marginBottom: '24px', fontSize: '14px' }}>Last updated: June 2026</p>

          <h3>1. Introduction</h3>
          <p>This Acceptable Use Policy ("AUP") sets out the rules and guidelines for using the Grand Gather Registry ("GGR") platform, website, and services. By accessing or using GGR, you agree to comply with this policy. We reserve the right to suspend or terminate access for users who violate this policy.</p>

          <h3>2. Who We Serve</h3>
          <p>Grand Gather Registry is a marketplace connecting event hosts with service vendors across South Africa. Our platform facilitates:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '16px', lineHeight: '1.8' }}>
            <li>Discovery and booking of event service providers (caterers, photographers, decorators, DJs, makeup artists, etc.)</li>
            <li>Event planning tools including guest management, invitations, ticketing, seating planning, and budget tracking</li>
            <li>Gift registry services allowing guests to contribute toward a couple's or host's selected gifts</li>
            <li>Subscription plans offering enhanced features for vendors and hosts</li>
          </ul>

          <h3>3. Prohibited Conduct</h3>
          <p>Users of the GGR platform must not:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '16px', lineHeight: '1.8' }}>
            <li><strong>Post illegal content:</strong> Share or promote any content that is unlawful, fraudulent, defamatory, hateful, discriminatory, or obscene</li>
            <li><strong>Impersonate others:</strong> Create fake profiles, misrepresent your identity or business, or impersonate another person or company</li>
            <li><strong>Circumvent the platform:</strong> Use GGR to find clients or vendors and then take the transaction off-platform to avoid commissions or fees. This includes sharing off-platform contact details before a booking is confirmed</li>
            <li><strong>Harass or abuse:</strong> Engage in harassment, bullying, threats, or abusive behaviour toward other users, vendors, hosts, or GGR staff</li>
            <li><strong>Spam or scam:</strong> Send unsolicited commercial messages, engage in phishing, or run scams targeting hosts, vendors, or guests</li>
            <li><strong>Post misleading listings:</strong> List services you do not actually provide, post fake pricing, or misrepresent your capabilities, credentials, or availability</li>
            <li><strong>Interfere with the platform:</strong> Attempt to hack, reverse-engineer, overload, or disrupt GGR's systems, APIs, or security measures</li>
            <li><strong>Game the system:</strong> Create multiple accounts to manipulate reviews, ratings, commissions, loyalty points, or search rankings</li>
            <li><strong>Violate laws:</strong> Use the platform in any way that violates South African or applicable international laws</li>
          </ul>

          <h3>4. Vendor Obligations</h3>
          <p>All vendors on GGR must:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '16px', lineHeight: '1.8' }}>
            <li>Provide accurate, truthful information about their business, services, pricing, and availability</li>
            <li>Maintain up-to-date rate cards and service descriptions</li>
            <li>Deliver services as described and agreed upon in confirmed bookings</li>
            <li>Respond to booking requests and host inquiries within a reasonable timeframe</li>
            <li>Keep all communication with hosts on the platform during the booking and delivery process</li>
            <li>Comply with South African consumer protection laws (CPA) and data protection regulations (POPIA)</li>
          </ul>

          <h3>5. Host Obligations</h3>
          <p>All hosts on GGR must:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '16px', lineHeight: '1.8' }}>
            <li>Provide accurate event details and requirements when posting bookings or requests</li>
            <li>Pay for confirmed bookings through the platform's payment system</li>
            <li>Not misuse vendors' contact information or attempt to circumvent the platform's booking and payment systems</li>
            <li>Treat vendors with respect and professionalism throughout the booking process</li>
          </ul>

          <h3>6. Content Standards</h3>
          <p>All content uploaded to GGR — including business profiles, gallery images, event descriptions, invitations, messages, and reviews — must:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '16px', lineHeight: '1.8' }}>
            <li>Be accurate and genuinely represent the business, event, or review being described</li>
            <li>Not infringe on any third party's intellectual property rights, including copyright, trademarks, or trade secrets</li>
            <li>Not contain malware, viruses, or harmful code</li>
            <li>Not include adult, explicit, or violent content</li>
          </ul>

          <h3>7. Enforcement</h3>
          <p>GGR reserves the right to:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '16px', lineHeight: '1.8' }}>
            <li>Remove any content that violates this policy</li>
            <li>Suspend or terminate accounts for policy violations</li>
            <li>Withhold funds or wallet balances in cases of fraud or serious misconduct</li>
            <li>Report illegal activity to relevant law enforcement authorities</li>
            <li>Take disciplinary action including warnings, temporary suspensions, or permanent bans</li>
          </ul>

          <h3>8. Reporting Violations</h3>
          <p>If you encounter content or behaviour that violates this policy, please report it immediately:</p>
          <ul style={{ paddingLeft: '20px', marginBottom: '16px', lineHeight: '1.8' }}>
            <li>Email: <a href="mailto:support@grandgatherregistry.co.za">support@grandgatherregistry.co.za</a></li>
            <li>WhatsApp: +27 61 391 1942</li>
            <li>In-app: Use the dispute reporting feature on any booking</li>
          </ul>

          <h3>9. Changes to This Policy</h3>
          <p>We may update this Acceptable Use Policy from time to time. Users will be notified of material changes via email or platform notification. Continued use of GGR after changes take effect constitutes acceptance of the revised policy.</p>
        </div>
      </div>
    </div>
  );
}
